import Checkbox from 'components/checkbox';
import ContentTypeTag from './ContentTypeTag';
import {
  CheckboxWrapper,
  ContentListItem,
  ContentRowRightWrapper,
  HitLabel,
  SearchResultsWrapper,
} from './styles';

export interface ICustomContentListItemView {
  id: string;
  uuid: string | null;
  name: string;
  description: string;
  content_type: string;
}

interface CustomContentResultsProps {
  items: ICustomContentListItemView[];
  selectedContent: Record<string, ICustomContentListItemView>;
  contentToExclude: Record<string, unknown>;
  onCheckContent: (item: ICustomContentListItemView) => void;
}

const CustomContentResults = ({
  items,
  selectedContent,
  contentToExclude,
  onCheckContent,
}: CustomContentResultsProps): JSX.Element => {
  return (
    <SearchResultsWrapper>
      {items.map((item) => {
        const isMissingUuid = !item.uuid;
        const isExcluded = !isMissingUuid && !!contentToExclude[item.uuid];
        const isDisabled = isMissingUuid || isExcluded;
        const isSelected = !!item.uuid && !!selectedContent[item.uuid];

        return (
          <ContentListItem key={item.id}>
            <CheckboxWrapper>
              <Checkbox
                style={{
                  fontWeight: '500',
                  fontSize: '14px',
                  lineHeight: '20px',
                }}
                checked={isSelected}
                onChange={() => !isDisabled && onCheckContent(item)}
                controlled
                disabled={isDisabled}
                aria-label={`${isSelected ? 'Deselect' : 'Select'} ${item.name}`}
              />
              <HitLabel
                disabled={isDisabled}
                onClick={() => !isDisabled && onCheckContent(item)}
                role="button"
                tabIndex={isDisabled ? -1 : 0}
                onKeyDown={(event) => {
                  if (isDisabled) return;
                  if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    onCheckContent(item);
                  }
                }}
              >
                {item.name}
              </HitLabel>
            </CheckboxWrapper>

            <ContentRowRightWrapper>
              <ContentTypeTag value={item.content_type} />
            </ContentRowRightWrapper>
          </ContentListItem>
        );
      })}
    </SearchResultsWrapper>
  );
};

export default CustomContentResults;
